import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid';
import { useAppSelector } from 'app/hooks';
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from 'components/layout/popover';
import { ReactNode } from 'react';
import {
  getEnvironmentInfo,
  getEnvironmentSwitcherLinks
} from 'utils/environment';
import { formatUserShortName } from 'utils/user';

type Props = {
  trailingBadge?: ReactNode;
};

export default function BrandingBadges({ trailingBadge }: Props) {
  const environmentInfo = getEnvironmentInfo();
  const environmentLinks = getEnvironmentSwitcherLinks();
  const userShortName = useAppSelector((state) =>
    formatUserShortName(state.auth.user?.name)
  );

  return (
    <div className='ml-auto flex items-center gap-2'>
      <span className='whitespace-nowrap font-medium text-neutral-300'>
        System Selector{userShortName ? ` (${userShortName})` : ''}
      </span>
      {environmentLinks.length > 0 ? (
        <Popover placement='bottom-end'>
          <PopoverTrigger asChild>
            <button
              type='button'
              className={`cursor-pointer rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${environmentInfo.badgeClassName}`}
            >
              {environmentInfo.label}
            </button>
          </PopoverTrigger>
          <PopoverContent className='z-50 min-w-[140px] rounded-md bg-neutral-800 p-1 shadow-lg'>
            {environmentLinks.map((link) => (
              <a
                key={link.environment}
                href={link.url}
                target='_blank'
                rel='noopener noreferrer'
                className='flex items-center justify-between gap-3 rounded px-2 py-1 hover:bg-neutral-700'
              >
                <span
                  className={`rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${link.badgeClassName}`}
                >
                  {link.label}
                </span>
                <ArrowTopRightOnSquareIcon className='h-3 w-3 text-neutral-400' />
              </a>
            ))}
          </PopoverContent>
        </Popover>
      ) : (
        <span
          className={`rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${environmentInfo.badgeClassName}`}
        >
          {environmentInfo.label}
        </span>
      )}
      {trailingBadge}
    </div>
  );
}
